<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6" v-if="!item['@id']">
          <v-file-input
            v-model="item.file"

            :error-messages="fileErrors"
            :label="$t('global.fileinput')"
            required
            show-size
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="serviceSelectItems"
            v-model="item.services"
            :items="serviceSelectItems"
            :error-messages="servicesErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('service.services')"
            item-text="name"
            item-value="@id"
            chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">

        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <v-textarea
            v-model="item.description"
            :error-messages="descriptionErrors"
            :label="$t('profile.description')"
            auto-grow
            required
            rows="1"
            row-height="15"
            @input="$v.item.description.$touch()"
            @blur="$v.item.description.$touch()"
          />
        </v-col>
      </v-row>


    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import { maxsizefile } from '../../utils/files';

export default {
  name: 'ProcessSchemaForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.serviceGetSelectItems({'orderCol'  : 'order[name]','order'  : 'asc'});
  },
  data() {
    return {
        name: null,
        file: null,
        services: null,
        description: null,
    };
  },
  computed: {
    isLoading() {
      return (
         this.isLoading_service
       );
    },
    ...mapFields('service', {
      serviceSelectItems: 'selectItems',
      isLoading_service : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    descriptionErrors() {
      const errors = [];
      if (!this.$v.item.description.$dirty) return errors;
      has(this.violations, 'description') && errors.push(this.violations.description);
      return errors;
    },
    fileErrors() {
      const errors = [];
      if (!this.$v.item.file.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.file);
      !this.$v.item.file.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    servicesErrors() {
      const errors = [];
      if (!this.$v.item.services.$dirty) return errors;
      has(this.violations, 'services') && errors.push(this.violations.services);
    //  !this.$v.item.machines.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      serviceGetSelectItems: 'service/fetchSelectItems'
    }),

  },
  validations: {
    item: {
      file: {
        maxsizefile : maxsizefile(20),
      },
      name: {
        required,
      },

      description: {
      },
      services: {
      },

    }
  }
};
</script>
